export const ROOT = '/';
export const USERS_LIST = '/users';
export const DROPSHIPPERS_LIST = '/dropshippers';
export const STORE = '/store/:guid';
export const STORE_SOURCE = '/store/';

export const CATALOG_CATEGORIES = '/categories';

export const WAREHOUSE_SUPPLIERS = '/suppliers';
export const CATALOG_CHARACTERISTIC_GROUPS = '/characteristic-groups';
export const CATALOG_CHARACTERISTICS = '/characteristics';
export const CATALOG_PRODUCTS = '/products';
export const CATALOG_ORDERS = '/orders';
export const CATALOG_ORDERS_STATUSES = '/orders/:status';
export const CATALOG_DELETED_ORDERS = '/deleted-orders';
export const SETTINGS_BUSINESS_PROCESSES = '/business-processes'
export const SETTINGS_ORDER_STATUSES = '/order-statuses';
export const SETTINGS_UTM = '/utm';
export const SETTINGS_MESSAGES_TEMPLATES = '/message-templates';
export const PRODUCTS_SHOWCASE = '/products-showcase/company/:base64';
export const PRODUCTS_SHOWCASE_ROOT = '/products-showcase/company/';
export const SETTINGS_CURRENCIES = '/currencies';
export const SETTINGS_PRODUCT_PRICE_GROUP = '/product-price-group';
export const SCANSHEET_ORDERS_LIST = '/scansheets/orders';
export const SCANSHEET_PRODUCTS_LIST = '/scansheets/products';
export const FINANCES_BANK_TRANSACTIONS_LIST = '/finances/bank-transactions';
export const LEADS_LIST = '/leads';
export const CLIENTS_LIST = '/clients';

export const MODULE_MANAGEMENT_LIST = '/modules';
export const MODULE_TURBOSMS_CONFIG = '/modules/turbosms/configure';
export const MODULE_IMPORT_CONFIG = '/modules/import/configure';
export const MODULE_NOVAPOSHTA_CONFIG = '/modules/novaposhta/configure';
export const MODULE_LP_MIGRATION_CONFIG = '/modules/lpcrm/configure';
export const MODULE_AFTERSHIP_CONFIG = '/modules/aftership/configure';
export const MODULE_NEXTEL_CONFIG = '/modules/nextel/configure';
export const MODULE_CMS_ORDERS_CONFIG = '/modules/beclearcms/configure';
export const MODULE_WAREHOUSE_CONFIG = '/modules/mywarehouse/configure';
export const MODULE_PROM_UA_CONFIG = '/modules/promua/configure';
export const MODULE_NPS_CONFIG = '/modules/nps/configure';
export const MODULE_ROZETKA_CONFIG = '/modules/rozetka/configure';
export const MODULE_DROPSHIPPER_CONFIG = '/modules/dropshipper/configure';
export const MODULE_SHOWCASE_CONFIG = '/modules/showcase/configure';
export const MODULE_TILDA_CONFIG = '/modules/tilda/configure';
export const MODULE_COMMERCE_ML = '/modules/commerceml/configure';
export const MODULE_BINOTEL_CONFIG = '/modules/binotel/configure';
export const MODULE_PHONET_CONFIG = '/modules/phonet/configure';
export const MODULE_HOROSHOP_CONFIG = '/modules/horoshop/configure';
export const MODULE_PRIVATBANK_CONFIG = '/modules/privatbank/configure';
export const MODULE_MONOBANK_CONFIG = '/modules/monobank/configure';
export const MODULE_CHATBOT_CONFIG = '/modules/chatbots/configure';
export const MODULE_EXCEL_IMPORT_CONFIG = '/modules/excelimport/configure';
export const MODULE_UKRPOSHTA_CONFIG = '/modules/ukrposhta/configure';
export const MODULE_PIPELINES_CONFIG = '/modules/pipelines/configure';
export const MODULE_CLIENT_ORDERS_CONFIG = '/modules/clientorders/configure';
export const MODULE_DOCS_TEMPLATES_CONFIG = '/modules/documenttemplates/configure';
export const MODULE_WAYFORPAY_CONFIG = '/modules/wayforpay/configure';
export const MODULE_EXPORT_CONFIG = '/modules/export/configure';

export const LOGIN = '/login';
export const REGISTRATION = '/registration';
export const LOGOUT = '/logout';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password/:token';

export const INVOICE_CREATE = '/invoice/create'
export const INVOICE_CREATE_PERSONAL = '/invoice/create-personal'
export const INVOICE_MODULES_CREATE = '/invoice/modules-create'
export const INVOICE_LIST = '/invoice'

export const MARKETING = '/marketing'
export const MARKETING_COSTS = '/marketing-costs'

export const PROFILE = '/profile';

export const REPORT = '/report';
export const NPS_ANALYTICS = '/nps-analytics';
export const REPORT_ORDERS_PRIME_COST = '/orders-prime-cost';
export const REPORT_CALLS = '/calls-report';

export const COMPANY_ACTIVITY = '/company-activity'
export const SYSTEM_ACTIONS = '/system-actions';
export const USER_TASKS = '/user-tasks'
export const USER_TASKS_TIMETABLE = '/user-tasks-timetable'

export const PIPELINE = '/pipeline'
export const CHAT = '/chat'

export const CUSTOMER_DEVELOPMENT = '/customer-development'

export const ORDER_FOR_CUSTOMER = '/l/:shortlink';

// export const DASHBOARD = '/:company/dashboard';
// export const REGISTER = '/register/:type/:step?';

// // Content manager routes
// export const CONTENT_MANAGER_ID = '/:company/content-manager/draft';
// export const CONTENT_MANAGER_DRAFT = '/:company/content-manager/draft/:id';
